import * as React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { tokens } from '../../Components/DashboardTheme/DashboardTheme';
import { Kicker, BodyText } from '../../Components/Typography/Typography';
import Reveal from '../../Components/Reveal/Reveal';
import Image from '../../img/img-maestro.webp';

const SECTIONS = [
  {
    heading: 'Passione & Disciplina',
    body: 'In ogni lezione, la passione e la disciplina sono i pilastri del nostro insegnamento. Credo che attraverso la dedizione e il duro lavoro, ognuno possa raggiungere vette di eccellenza sia dentro che fuori dalla palestra.',
  },
  {
    heading: 'Cosa ci distingue',
    body: 'La nostra palestra si distingue per l\'ambiente unico. Qui, ogni membro è parte di una famiglia allargata, unita dall\'amore per la Muay Thai. Forniamo un ambiente di supporto dove tutti — dai principianti ai combattenti professionisti — possono crescere, imparare e superare i propri limiti.',
  },
  {
    heading: 'Il sudore ripaga sempre',
    body: 'Ogni sessione di allenamento è un\'opportunità per superare se stessi, per trasformare la fatica in vittorie. Crediamo che la perseveranza e l\'impegno siano la chiave per raggiungere obiettivi sia fisici che mentali. Ogni goccia di sudore rappresenta un passo avanti verso il raggiungimento dell\'obiettivo.',
  },
];

export default function StoryVivenzioGym() {
  const theme = useTheme();
  const isScreenMedium = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ backgroundColor: tokens.ink, minHeight: '100vh' }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: isScreenMedium ? '1fr' : '1fr 1fr',
          minHeight: '100vh',
        }}
      >
        {/* ---------- Portrait ---------- */}
        <Box sx={{ height: { xs: '52vh', md: 'auto' } }}>
          {/* Sticks alongside the copy column on desktop. */}
          <Box
            sx={{
              position: { xs: 'relative', md: 'sticky' },
              top: 0,
              height: { xs: '100%', md: '100vh' },
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={Image}
              alt="Mario Vivenzio, maestro di Muay Thai"
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center 25%',
                filter: 'grayscale(35%) brightness(0.72) contrast(1.05)',
              }}
            />
            <Box
              aria-hidden
              sx={{
                position: 'absolute',
                inset: 0,
                background: {
                  xs: `linear-gradient(180deg, transparent 40%, ${tokens.ink} 100%)`,
                  md: `linear-gradient(90deg, transparent 55%, ${tokens.ink} 100%)`,
                },
                pointerEvents: 'none',
              }}
            />
          </Box>
        </Box>

        {/* ---------- Copy ---------- */}
        <Box
          sx={{
            px: { xs: 3, md: 7 },
            py: { xs: 6, md: 14 },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Reveal>
            <Kicker justifyContent="flex-start">La nostra storia</Kicker>
            <Box
              component="h1"
              sx={{
                m: 0,
                mt: 2,
                fontFamily: tokens.display,
                fontSize: { xs: 54, md: 88 },
                lineHeight: 0.92,
                color: tokens.white,
              }}
            >
              MUAY THAI
            </Box>
            <BodyText
              textAlign="left"
              maxWidth="100%"
              color={tokens.white}
              fontSize={{ xs: 17, md: 19 }}
              sx={{ mt: 3, fontWeight: 300 }}
            >
              La Muay Thai, nota come l'arte degli otto arti, è più di una semplice disciplina
              sportiva: è una ricca tradizione culturale della Thailandia. Nella mia palestra,
              dedichiamo ogni momento all'insegnamento e alla pratica di questa antica arte marziale,
              enfatizzando sia la sua potenza fisica che la sua profondità spirituale.
            </BodyText>
          </Reveal>

          {SECTIONS.map((section, i) => (
            <Reveal key={section.heading} delay={i * 90}>
              <Box sx={{ mt: { xs: 4.5, md: 6 } }}>
                <Box
                  sx={{
                    fontFamily: tokens.heading,
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                    fontSize: { xs: 22, md: 26 },
                    color: tokens.white,
                  }}
                >
                  {section.heading}
                </Box>
                <Box aria-hidden sx={{ width: 44, height: 2, backgroundColor: tokens.red, my: 1.75 }} />
                <BodyText textAlign="left" maxWidth="100%">
                  {section.body}
                </BodyText>
              </Box>
            </Reveal>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
